// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"jZ","information":"j0"};